import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";
import type { ReactNode } from "react";
import { PageState, type PageStateKind } from "@/components/ui/PageState";

/** 권한·없는 주소 안내. [이전 페이지] 는 앱 내 기록 → 브라우저 기록 → 내 업무 순으로 돌아간다. */
export function RouteState({ kind, description }: { kind: PageStateKind; description: ReactNode }) {
  const navigate = useNavigate();
  const canGoBack = typeof window.history.state?.idx === "number" && window.history.state.idx > 0;
  // 버튼 2개 고정: [이전 페이지](ghost) | [내 업무](primary). 앱 내 기록이 없으면 브라우저 뒤로, 그것도 없으면 내 업무.
  const goBack = () => {
    if (canGoBack) navigate(-1);
    else if (window.history.length > 1) window.history.back();
    else navigate("/my", { replace: true });
  };
  return <PageState kind={kind} description={description}
    actionLabel="내 업무" onAction={() => navigate("/my", { replace: true })}
    secondaryAction={<button type="button" className="btn-ghost" onClick={goBack}>이전 페이지</button>} />;
}

/** 라우트 렌더·lazy 청크 오류. 깨진 컨텍스트에 의존하지 않고 복구 경로 제공. */
export function RouteError() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : undefined;
  if (status === 403) return <RouteState kind="denied" description="이 페이지를 볼 권한이 없어요. 관리자에게 문의해 주세요." />;
  if (status === 404) return <RouteState kind="not-found" description="주소가 바뀌었거나 없는 페이지예요. 주소를 다시 확인해 주세요." />;
  return <PageState kind="error"
    description={<>화면을 불러오지 못했어요.<br />연결 상태를 확인한 뒤 다시 시도해 주세요.</>}
    actionLabel="새로고침" onAction={() => window.location.reload()}
    secondaryAction={<a className="btn-ghost" href="/my">내 업무</a>} />;
}
